import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Definitionscertificate_interface, Empty_Definitionscertificate_interface } from 'src/app/Interface/Definitionscertificate_interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DefinitionscertificateService } from 'src/app/Service/Definitionscertificate/Definitionscertificate.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-DefinitionscertificateList',
  templateUrl: './DefinitionscertificateList.component.html',
  styleUrls: ['./DefinitionscertificateList.component.scss']
})
export class DefinitionscertificateListComponent implements OnInit {
  Filter_quantity:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private Definitionscertificate_Service:DefinitionscertificateService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_Definitionscertificate:Array<Definitionscertificate_interface>=[]
  Data_Seleted_Delete:Definitionscertificate_interface=Empty_Definitionscertificate_interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(1079).subscribe(
      data=>{
        this.ReadData_Definitionscertificate()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Definitionscertificate(){
    this.Procssing=true
    this.Definitionscertificate_Service.GetRecord().subscribe(
      data=>{
        this.DataList_Definitionscertificate=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:Definitionscertificate_interface){
    this.modalRef_Delete.hide()
    this.Definitionscertificate_Service.DeleteDefinitionscertificate(item.id).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("حذف شد")
        this.ReadData_Definitionscertificate()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }


  exportexcel(): void
  {
     /* table id is passed over here */
     let element = document.getElementById('excel-table');
     const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     /* save to file */
     XLSX.writeFile(wb, "Daro.xlsx");

  }


}
